import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=271a3f50&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a3f50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271a3f50')) {
      api.createRecord('271a3f50', component.options)
    } else {
      api.reload('271a3f50', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=271a3f50&scoped=true&", function () {
      api.rerender('271a3f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/master_client_company/detail.vue"
export default component.exports